import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataBase, DBResponse, Credenciales, LoginResponse, Message, PassRecover, RefreshTokenResponse, UsuarioAuthenticado } from '@shared/models/login-response.model';
import { BYPASS_JW_TOKEN } from '@shared/interceptors/token.interceptor';
import { catchError, from, map, Observable, switchMap, throwError } from 'rxjs';
import { StorageService } from '@shared/services/storage/storage.service';
import { TokenService } from '../token/token.service';
import { ApiResponse } from '@shared/models/api-response.model';
import { ChangePass, ChangePassResp } from '@shared/models/change-pass.model';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly API = environment.API_URL;

  private readonly _http = inject(HttpClient);

  private readonly _storage = inject(StorageService);
  private readonly _token = inject(TokenService);

  login(credenciales: Credenciales): Observable<UsuarioAuthenticado> {
    return this._http
      .post<ApiResponse<LoginResponse>>(`${this.API}/Auth/Login`, credenciales, {
        context: new HttpContext().set(BYPASS_JW_TOKEN, true),
      })
      .pipe(
        map(({ value: { user } }) => {
          return user;
        }),
      );
  }

  refreshToken(): Observable<RefreshTokenResponse> {
    return from(this._storage.getItem('refresh_token')).pipe(
      switchMap((refresh_token: string) => {
        if (!refresh_token) {
          return throwError(() => new Error('No refresh token available'));
        }
        const params = new HttpParams().appendAll({ RefreshTkn: refresh_token });
        const headers = new HttpHeaders({
          Authorization: `Bearer ${refresh_token}`,
        });

        return this._http
          .get<ApiResponse<RefreshTokenResponse>>(`${this.API}/Auth/RefreshToken`, {
            context: new HttpContext().set(BYPASS_JW_TOKEN, true),
            headers,
            params,
          })
          .pipe(
            map(({ value }) => {
              const { token, refresh_token } = value;
              this._token.token.set(token);
              this._token.refresh_token.set(refresh_token);
              this._storage.setItem('token', token);
              this._storage.setItem('refresh_token', refresh_token);
              return value;
            }),
            catchError((error) => {
              console.error('Error during token refresh:', error);
              return throwError(() => new Error('Token refresh failed'));
            }),
          );
      }),
    );
  }

  seleccionarBase(db: DataBase): Observable<DBResponse> {
    const params = new HttpParams().append('idBase', db.idBase);

    return this._http
      .get<ApiResponse<DBResponse>>(`${this.API}/Auth/SeleccionaBaseDeDatos`, {
        params,
      })
      .pipe(map(({ value }) => value));
  }

  recoveryPass(data: PassRecover): Observable<string> {
    return this._http
      .post<ApiResponse<Message>>(`${this.API}/Auth/Request-Pass`, data, {
        context: new HttpContext().set(BYPASS_JW_TOKEN, true),
      })
      .pipe(
        map(({ value }) => {
          return value.mensaje;
        }),
      );
  }

  changePass(data: ChangePass): Observable<string> {
    return this._http.post<ApiResponse<ChangePassResp>>(`${this.API}/Auth/Change-Pass`, data).pipe(map(({ value }) => value.mensaje));
  }
}
